// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6b96c194","839":"c44fedeb"}[chunkId] + ".chunk.js";
};